export default __webpack_public_path__ + "static/media/_DSC0370.9a9c020e.JPG";